module.exports = __webpack_public_path__ + "static/media/landing-kitty01.bd742ede.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty01.svg
// module id = 118
// module chunks = 0